<aside
    class="sidebar-recent-chats"
    [class.collapsed]="sidebarCollapsed"
    [class.sidebar-hidden-mobile]="renameModal.visible || deleteModal.visible"
>
    <div class="sidebar-recent-chats__section__search">
        <div class="sidebar-search-row">
            <input
                id="searchChats"
                #searchInput
                type="text"
                placeholder="Search chats..."
                [value]="searchQuery"
                (input)="onSearch(searchInput.value)"
                aria-label="Search chats"
                [attr.disabled]="sidebarCollapsed ? true : null"
                *ngIf="!sidebarCollapsed"
            />
            <button
                class="search-clear-btn"
                *ngIf="!sidebarCollapsed && searchQuery"
                (click)="clearSearch()"
                aria-label="Clear search"
            >
                <img src="/assets/icons/remove-icon.svg" alt="Clear" />
            </button>
        </div>
    </div>

    <!-- Collapsed icon bar (shown only when sidebar is collapsed) -->
    <div
        class="collapsed-icons"
        *ngIf="sidebarCollapsed"
        role="toolbar"
        aria-label="Collapsed sidebar actions"
    >
        <button
            class="collapsed-icon-btn"
            aria-label="New Chat"
            data-tooltip="New Chat"
            (click)="onCollapsedNewChat()"
            [aidaTooltip]="'New Chat'"
        >
            <img src="/assets/icons/new-chat-white.svg" alt="New Chat" />
        </button>
        <button
            class="collapsed-icon-btn"
            aria-label="Search chats"
            data-tooltip="Search chats"
            (click)="onCollapsedSearch()"
            [aidaTooltip]="'Search chats'"
        >
            <img src="/assets/icons/search-white.svg" alt="Search" />
        </button>
        <button
            class="collapsed-icon-btn"
            aria-label="Recent chats"
            data-tooltip="Recent chats"
            (click)="onCollapsedRecent()"
            [aidaTooltip]="'Recent chats'"
        >
            <img src="/assets/icons/recent-white.svg" alt="Recent" />
        </button>
        <button
            class="collapsed-icon-btn"
            aria-label="Favorites"
            data-tooltip="Favorites"
            (click)="onCollapsedFavorites()"
            [aidaTooltip]="'Favorites'"
        >
            <img src="/assets/icons/favorite-white.svg" alt="Favorites" />
        </button>
    </div>

    <!-- Tooltip is now handled by AidaTooltipDirective -->
    <!-- RECENT as accordion -->
    <div class="sidebar-recent-chats__section recent-section" *ngIf="!sidebarCollapsed">
        <details
            class="accordion-details"
            [open]="recentOpen"
            (toggle)="onRecentDetailsToggle($event)"
        >
            <summary class="sidebar-recent-chats__section__title">
                <div class="title-left">
                    <span class="title-text">Recent</span>
                    <span class="title-count">({{ displayedRecents.length }})</span>
                </div>
                <img src="../../../../assets/icons/chevron-down.svg" alt="toggle" />
            </summary>
            <div
                class="sidebar-recent-chats__section__scroll-container"
                tabindex="0"
                id="recent-list"
            >
                <ul class="sidebar-recent-chats__section__scroll-container__list">
                    <li
                        class="sidebar-recent-chats__section__scroll-container__list__item"
                        *ngFor="let chatItem of displayedRecents | slice: 0 : recentLimit"
                        [class.active]="selectedChatId === chatItem.conversationId"
                        [aidaTooltip]="
                            !!openMenuChatId || renameModal.visible || deleteModal.visible
                                ? ''
                                : chatItem.title
                        "
                        [aidaTooltipDisabled]="
                            !!openMenuChatId || renameModal.visible || deleteModal.visible
                        "
                        role="button"
                        tabindex="0"
                        (click)="selectChat(chatItem)"
                        (keydown.enter)="selectChat(chatItem)"
                        (keydown.space)="$event.preventDefault(); selectChat(chatItem)"
                    >
                        <span
                            class="sidebar-recent-chats__section__scroll-container__list__item__text"
                            >{{ chatItem.title | truncate: 120 }}</span
                        >
                        <button
                            class="chat-options-btn"
                            [class.chat-options-btn--active]="
                                openMenuChatId === chatItem.conversationId
                            "
                            [attr.aria-label]="'More options for ' + chatItem.title"
                            (click)="toggleOptions(chatItem.conversationId, $event)"
                        >
                            ⋮
                        </button>
                        <div
                            *ngIf="openMenuChatId === chatItem.conversationId"
                            class="chat-options-menu"
                            [ngStyle]="{ top: menuPosition.top, left: menuPosition.left }"
                        >
                            <button (click)="renameChat(chatItem)">
                                <img src="../../../../assets/edit.png" alt="edit" /> Rename
                            </button>
                            <button (click)="deleteChat(chatItem)">
                                <img src="../../../../assets/trash.png" alt="delete" /> Delete
                            </button>
                            <button (click)="markAsFavoriteChat(chatItem)">
                                <img src="../../../../assets/star.png" alt="favorite" /> Favorite
                            </button>
                        </div>
                    </li>
                </ul>
            </div>
            <span
                class="sidebar-recent-chats__section__show-more"
                *ngIf="displayedRecents.length > 10"
                (click)="toggleShowMore('recent')"
                [ngClass]="{ expanded: recentLimit > 10 }"
            >
                <img src="../../../../assets/icons/chevron-down.svg" alt="chevron-down" />
                {{ recentLimit === 10 ? 'Show more' : 'Show less' }}
            </span>
        </details>
    </div>
    <!-- FAVORITES as accordion -->
    <div class="sidebar-recent-chats__section favorites-section" *ngIf="!sidebarCollapsed">
        <details
            class="accordion-details"
            [open]="favoritesOpen"
            (toggle)="onFavoritesDetailsToggle($event)"
        >
            <summary class="sidebar-recent-chats__section__title">
                <div class="title-left">
                    <span class="title-text">Favorites</span>
                    <span class="title-count">({{ displayedFavorites.length }})</span>
                </div>
                <img src="../../../../assets/icons/chevron-down.svg" alt="toggle" />
            </summary>
            <div
                class="sidebar-recent-chats__section__scroll-container"
                tabindex="0"
                id="favorites-list"
            >
                <ul class="sidebar-recent-chats__section__scroll-container__list">
                    <li
                        class="sidebar-recent-chats__section__scroll-container__list__item"
                        *ngFor="let chatItem of displayedFavorites | slice: 0 : favoriteLimit"
                        [class.active]="selectedChatId === chatItem.conversationId"
                        [aidaTooltip]="
                            !!openMenuChatId || renameModal.visible || deleteModal.visible
                                ? ''
                                : chatItem.title
                        "
                        [aidaTooltipDisabled]="
                            !!openMenuChatId || renameModal.visible || deleteModal.visible
                        "
                        role="button"
                        tabindex="0"
                        (click)="selectChat(chatItem)"
                        (keydown.enter)="selectChat(chatItem)"
                        (keydown.space)="$event.preventDefault(); selectChat(chatItem)"
                    >
                        <span
                            class="sidebar-recent-chats__section__scroll-container__list__item__text"
                            >{{ chatItem.title | truncate: 120 }}</span
                        >
                        <button
                            class="chat-options-btn"
                            [class.chat-options-btn--active]="
                                openMenuChatId === chatItem.conversationId
                            "
                            [attr.aria-label]="'More options for ' + chatItem.title"
                            (click)="toggleOptions(chatItem.conversationId, $event)"
                        >
                            ⋮
                        </button>
                        <div
                            *ngIf="openMenuChatId === chatItem.conversationId"
                            class="chat-options-menu"
                            [ngStyle]="{ top: menuPosition.top, left: menuPosition.left }"
                        >
                            <button (click)="renameChat(chatItem)">
                                <img src="../../../../assets/edit.png" alt="edit" /> Rename
                            </button>
                            <button (click)="deleteChat(chatItem)">
                                <img src="../../../../assets/trash.png" alt="delete" /> Delete
                            </button>
                            <button (click)="unMarkAsFavoriteChat(chatItem)">
                                <img src="../../../../assets/star.png" alt="unmark favorite" />
                                Unmark favorite
                            </button>
                        </div>
                    </li>
                </ul>
            </div>
        </details>
    </div>
</aside>

<historical-modal
    [visible]="renameModal.visible"
    [oldTitle]="renameModal.oldTitle"
    [action]="renameModal.action"
    [(newTitle)]="renameModal.newTitle"
    (cancel)="closeRenameModal()"
    (confirm)="confirmRename()"
></historical-modal>

<historical-modal
    [visible]="deleteModal.visible"
    [oldTitle]="deleteModal.oldTitle"
    [action]="deleteModal.action"
    [(newTitle)]="deleteModal.newTitle"
    (cancel)="closeDeleteModal()"
    (confirm)="confirmDelete()"
></historical-modal>
